export  const SidebarVisibleAction = () =>{
    return {
        type: 'SIDEBAR_TOGGLE'
    }
}
